import React, { Dispatch, useCallback, useEffect } from "react";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

import { Label } from "../ui/label";
import { useAppDispatch, useAppSelector } from "@/app/hooks";
import {
  selectLeaveTypes,
  selectLeaveTypesError,
  selectLeaveTypesStatus,
} from "@/features/leaveTypes/leaveTypeSelector";
import { Loader2 } from "lucide-react";
import { useLeaveTypes } from "@/context/LeaveTypesContext";
import { LeaveType } from "@/models/leave-types.model";

interface Props {
  setSelectedLeaveType: Dispatch<React.SetStateAction<string>>;
}

function LeaveTypeDropdown({ setSelectedLeaveType }: Props) {
  const { leaveTypes, loading, error } = useLeaveTypes();

  return (
    <div className="flex flex-col gap-2">
      <Label>Leave Type</Label>
      <Select
        onValueChange={(value) => setSelectedLeaveType(value)}
        defaultValue={""}
      >
        <SelectTrigger className="w-[180px]">
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          {loading ? (
            <Loader2 className="animate-spin" />
          ) : leaveTypes && leaveTypes.length > 0 ? (
            leaveTypes.map((leaveType: LeaveType) => (
              <SelectItem key={leaveType.id} value={leaveType.name}>
                {leaveType.name}
              </SelectItem>
            ))
          ) : (
            <p className="px-2">No leave types available</p>
          )}
        </SelectContent>
      </Select>
    </div>
  );
}

export default LeaveTypeDropdown;
